
import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/Auth/AuthContext'; // Adjust the path based on your file structure
import RequireAuth from './components/Auth/RequireAuth'; // Adjust the path
import 'react-tooltip/dist/react-tooltip.css';
import SignIn from './components/Auth/SignIn';
import Header from './components/Header/Header'; 
import Dashboard from './Pages/Dashboard';
import MyCalendar from './Pages/Tasks/MyCalendar';
import CreateStudentForm from './Pages/CreateUserform/CreateStudentForm';
import CreateTeacherForm from './Pages/CreateUserform/CreateTeacherForm';
import { useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import Teacher from './Pages/Teacher/Teacher';
import Subject from './Pages/Subject/Subject';
import ClassDetails from './Pages/Class/ClassDetails';
import ClassDetailsStudent from './Pages/Class/ClassDetailsStudent';
import MyPerformance from './Pages/Student/MyPerformance';
import StudentBilling from './Pages/Student/StudentBilling';
import StudentPerformance from './Pages/Student/StudentPerformance';
import AllClasses from './Pages/Class/AllClasses';
import Classroom from './Pages/Classroom/Classroom';
import UserControlPage from './Pages/UserControlPage/UserControlPage';
import ChangePasswordPage from './Pages/UserControlPage/ChangePasswordPage';
import AdminPanel from './Pages/AdminPanel/AdminPanel';
import AnnouncementList from './Pages/Announcement/AnnouncementList';
import TeacherDashboard from './Pages/Teacher/TeacherDashboard';
import StudentDashboard from './Pages/Student/StudentDashboard';
import Registrations from './Pages/Registration/Registrations';
import TeacherDashboardAdmin from './Pages/Teacher/TeacherDashboardAdmin';
import StudentDashboardAdmin from './Pages/Student/StudentDashboardAdmin';
import Reports from './Pages/Report/Reports';
import Accounting from './Pages/Accounting/Accounting';
import AdminDashboard from './Pages/AdminDashboard';
import TeacherHours from './Pages/Teacher/TeacherHours';
import TeacherHoursAdmin from './Pages/Teacher/TeacherHoursAdmin';
import TeacherDetailsPage from './Pages/Teacher/TeacherDetailsPage';
import ChatPage from './Pages/Chat/ChatPage';
import Footer from './components/Footer/Footer';
import DoodlePage from './Pages/Doodle/DoodlePage';
import Sales from './Pages/Registration/Sales';
import RegistrationList from './Pages/Registration/RegistrationList';
import LessonPlanPage from './Pages/Teacher/LessonPlanPage';
import SalesDashboardTabs from './Pages/Sales/SalesDashboardTabs';
import CreateQuotation from './Pages/Registration/CreateQuotation';
import CoursePage from './Pages/Class/CoursePage';



function App() {
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

  // This function updates the userData state
  const handleSetUserData = (data: any) => {
    setUserData(data);
  };

  // Cast wrapped components to accept any props
  const DashboardAny = Dashboard as any;
  const MyCalendarAny = MyCalendar as any;
  const AnnouncementListAny = AnnouncementList as any;
  const CreateStudentFormAny = CreateStudentForm as any;
  const CreateTeacherFormAny = CreateTeacherForm as any;
  const TeacherAny = Teacher as any;
  const SubjectAny = Subject as any;
  const ClassDetailsAny = ClassDetails as any;
  const CoursePageAny = CoursePage as any;
  const AllClassesAny = AllClasses as any;
  const ClassroomAny = Classroom as any;
  const UserControlPageAny = UserControlPage as any;
  const AdminDashboardAny = AdminDashboard as any;
  const TeacherHoursAny = TeacherHours as any;
  const TeacherHoursAdminAny = TeacherHoursAdmin as any;

  const handleSignOut = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/signin');
 };

  return (
    <AuthProvider>
      {isAuthenticated && <Header onSignOut={handleSignOut} />}
      {isAuthenticated && <Sidebar/>}
      {isAuthenticated && <Footer />}
      <Routes>
        <Route path="/signin" element={<SignIn setUserData={handleSetUserData} />} />
        <Route path="/dashboard" element={<RequireAuth><DashboardAny userData={userData} /></RequireAuth>} />
        <Route path="/calendar" element={<RequireAuth><MyCalendarAny userData={userData} /></RequireAuth>} />
        <Route path="/announcement" element={<RequireAuth><AnnouncementListAny userData={userData} /></RequireAuth>} />
        <Route path="/createstudentform" element={<RequireAuth><CreateStudentFormAny userData={userData} /></RequireAuth>} />
        <Route path="/createteacherform" element={<RequireAuth><CreateTeacherFormAny userData={userData} /></RequireAuth>} />
        <Route path="/teacher" element={<RequireAuth><TeacherAny userData={userData} /></RequireAuth>} />
        <Route path="/subject" element={<RequireAuth><SubjectAny userData={userData} /></RequireAuth>} />
        <Route path="/classdetails/:groupid" element={<RequireAuth><ClassDetailsAny userData={userData} /></RequireAuth>} />
        <Route path="/classdetailsstudent/:groupid" element={<RequireAuth><ClassDetailsStudent /></RequireAuth>} />
        <Route path="/course/:groupid" element={<RequireAuth><CoursePageAny userData={userData} /></RequireAuth>} />
        <Route path="/myperformance" element={<RequireAuth><MyPerformance /></RequireAuth>} />
        <Route path="/studentbilling" element={<RequireAuth><StudentBilling /></RequireAuth>} />
        <Route path="/studentperformance/:id" element={<RequireAuth><StudentPerformance /></RequireAuth>} />
        <Route path="/allclasses" element={<RequireAuth><AllClassesAny userData={userData} /></RequireAuth>} />
        <Route path="/classroom" element={<RequireAuth><ClassroomAny userData={userData} /></RequireAuth>} />
        <Route path="/usercontrolpage" element={<RequireAuth><UserControlPageAny userData={userData} /></RequireAuth>} />
        <Route path="/adminpanel" element={<RequireAuth><AdminPanel /></RequireAuth>} />
        <Route path="/teacher-dashboard/:id" element={<RequireAuth><TeacherDashboard /></RequireAuth>} />
        <Route path="/student-dashboard/:id" element={<RequireAuth><StudentDashboard /></RequireAuth>} />
        <Route path="/teacher-dashboard-admin/:id" element={<RequireAuth><TeacherDashboardAdmin /></RequireAuth>} />
        <Route path="/student-dashboard-admin/:id" element={<RequireAuth><StudentDashboardAdmin /></RequireAuth>} />
        <Route path="/registrations" element={<RequireAuth><Registrations /></RequireAuth>} />
        <Route path="/accounting" element={<RequireAuth><Accounting /></RequireAuth>} />
        <Route path="/report" element={<RequireAuth><Reports /></RequireAuth>} />
        <Route path="/admindashboard" element={<RequireAuth><AdminDashboardAny userData={userData} /></RequireAuth>} />
        <Route path="/teacher-hours" element={<RequireAuth><TeacherHoursAny userData={userData} /></RequireAuth>} />
        <Route path="/teacher-hours-admin" element={<RequireAuth><TeacherHoursAdminAny userData={userData} /></RequireAuth>} />
        <Route path="/teacher-details/:teacherId" element={<RequireAuth><TeacherDetailsPage /></RequireAuth>} />
        <Route path="/chat" element={<RequireAuth><ChatPage /></RequireAuth>} />
        <Route path="/doodle" element={<RequireAuth><DoodlePage /></RequireAuth>} />
        <Route path="/sales" element={<RequireAuth><Sales /></RequireAuth>} />
        <Route path="/registrationlist" element={<RequireAuth><RegistrationList /></RequireAuth>} />
        <Route path="/lessonplan" element={<RequireAuth><LessonPlanPage /></RequireAuth>} />
        <Route path="/sales-person" element={<RequireAuth><SalesDashboardTabs /></RequireAuth>} />
        <Route path="/quotation" element={<RequireAuth><CreateQuotation /></RequireAuth>} />
        <Route path="/change-password" element={<RequireAuth><ChangePasswordPage /></RequireAuth>} />
        <Route path="/" element={<SignIn setUserData={handleSetUserData} />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
